import React from "react";
import { connect } from "react-redux";
import * as campaignsRedux from "../../modules/campaigns/redux/campaignsRedux";
import { post } from "app/popleads/networking/RequestService";
import * as util from "../../app/functions/util";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import SVG from "react-inlinesvg";

const AttendanceActions = ({ selectedAttendanceListFromFilter, user }) => {
    const downloadAttendanceReport = () => {
        const requestObj = {
            fn: "getCampaign",
            campaignId: selectedAttendanceListFromFilter[0].value,
        };
        // isCampaignOver ?
        post(requestObj).then((response) => {
            const reportUrl =
                user.company.companyConfig.ecommerceSiteURL + "/export-attendance/" + response.data.campaign.slug;
            const name = response.data.campaign.slug + ".pdf";
            const authToken = util.getCookieValue(util.getCookieName());
            const url =
                window.location.protocol +
                "//" +
                window.location.host +
                "/api/ws/download/" +
                name +
                "?token=" +
                authToken +
                "&url=" +
                reportUrl;
            window.open(url, "_blank");
        });
        // : toast.error("Course is not over yet.");
    };

    const getQrCode = () => {
        const requestObj = {
            fn: "getUniqueLinkForSurvey",
            campaignId: selectedAttendanceListFromFilter[0].value,
        };

        post(requestObj).then((response) => {
            window.open("/api/ws/createQrCode?url=" + response.data.link);
        });
    };

    return (
        <div>
            <div className="d-flex align-items-center pdf-mobile ml-2" style={{ gap: "8px" }}>
                <ButtonWithText buttonStyle="selectedOption" variant="neutral" onClick={getQrCode}>
                    <SVG src="/media/svg/popleads/qr-english.svg" />
                </ButtonWithText>
                <ButtonWithText buttonStyle="selectedOption" variant="danger" onClick={downloadAttendanceReport}>
                    <SVG src="/media/svg/popleads/pdf.svg" />
                </ButtonWithText>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        selectedAttendanceListFromFilter: state.campaigns.selectedAttendanceListFromFilter,
        isCampaignOver: state.campaigns.isCampaignOver,
        user: state.auth.user,
    };
};

const mapDispatchToProps = {
    ...campaignsRedux.actions,
};

export default connect(mapStateToProps, mapDispatchToProps)(AttendanceActions);
